import { render, staticRenderFns } from "./RequestFormButtons.vue?vue&type=template&id=77c79228&"
import script from "./RequestFormButtons.vue?vue&type=script&lang=ts&"
export * from "./RequestFormButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports